import React, { useState } from 'react';
import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { BsChevronRight, BsExclamationTriangleFill } from 'react-icons/bs';
import {
  IMPORTANT_NOTICE_ENABLED,
  IMPORTANT_NOTICE_PARAGRAPHS,
  IMPORTANT_NOTICE_TITLE,
} from './importantNoticeContent';

const ImportantNoticeButton: React.FC = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  if (!IMPORTANT_NOTICE_ENABLED || IMPORTANT_NOTICE_PARAGRAPHS.length === 0) {
    return null;
  }

  return (
    <>
      <div className="w-100 py-2 px-2">
        <Alert variant="danger" className="mb-0 py-3 border border-danger">
          <div className="d-flex justify-content-center align-items-center">
            <Button
              variant="light"
              size="lg"
              className="fw-semibold px-4 py-2 min-w-200 shadow-lg d-inline-flex align-items-center justify-content-center gap-2 text-danger border border-2 border-danger rounded-3"
              onClick={handleShow}
            >
              <BsExclamationTriangleFill className="flex-shrink-0" aria-hidden />
              <span>
                {IMPORTANT_NOTICE_TITLE}を表示
              </span>
              <BsChevronRight className="flex-shrink-0" aria-hidden />
            </Button>
          </div>
        </Alert>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        scrollable
        fullscreen="sm-down"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{IMPORTANT_NOTICE_TITLE}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {IMPORTANT_NOTICE_PARAGRAPHS.map((lines, i) => (
            <p key={i} className="mb-3 text-break">
              {lines.map((line, j) => (
                <React.Fragment key={j}>
                  {j > 0 ? <br /> : null}
                  {line}
                </React.Fragment>
              ))}
            </p>
          ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            閉じる
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ImportantNoticeButton;
